module.exports = __webpack_public_path__ + "img/pilates5.dcb841f8.jpg";